// extracted by mini-css-extract-plugin
module.exports = {"accordionGroup":"_0f1e75f"};